export const enum FeedbackRateInFiveScale {
  VERY_SATISFIED = 'Very Satisfied',
  SATISFIED = 'Satisfied',
  NEUTRAL = 'Neutral',
  DISSATISFIED = 'Dissatisfied',
  VERY_DISSATISFIED = 'Very Dissatisfied',
}

export const feedbackInScaleFiveConfig = {
  [FeedbackRateInFiveScale.VERY_DISSATISFIED]: {
    id: FeedbackRateInFiveScale.VERY_DISSATISFIED,
    label: '😭',
  },
  [FeedbackRateInFiveScale.DISSATISFIED]: {
    id: FeedbackRateInFiveScale.DISSATISFIED,
    label: '🙁',
  },
  [FeedbackRateInFiveScale.NEUTRAL]: {
    id: FeedbackRateInFiveScale.NEUTRAL,
    label: '😐',
  },
  [FeedbackRateInFiveScale.SATISFIED]: {
    id: FeedbackRateInFiveScale.SATISFIED,
    label: '😊',
  },
  [FeedbackRateInFiveScale.VERY_SATISFIED]: {
    id: FeedbackRateInFiveScale.VERY_SATISFIED,
    label: '🤩',
  },
};
